import React, { useState, FocusEvent } from "react";
import { Form, Col, Card, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AccountUIActionTypes, AdminUIActionTypes } from "src/common";
import connectionImage from "src/assets/images/connection.svg";

type AllProps = {
  handleAction: ActionHandlerFunction;
}

// Description: This component directs the user to enter a pin to approve the data export request.
function EstablishedConnectionComponent(props: AllProps) {
  const { handleAction } = props;
  const [pin, setPin] = useState<string>("");

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      handleAction({ actionType: AccountUIActionTypes.TransferKeyRequest, params: { pin: form.pin.value } });
    }
  }

  function handleCancel() {
    handleAction({ actionType: AdminUIActionTypes.Destroy });
  }

  return <Card className="pv-card">
    <Card.Img variant="top" src={connectionImage} />
    <Card.Body>
      <h3><i className="connected"></i> Connection Active </h3>
      <h4>Enter the 8-digit code that you were provided</h4>
      <Form noValidate onSubmit={handleSubmit} >
        <Form.Group as={Col} xs="8" className="mb-3">
          <Form.Label htmlFor="device_code_tb" visuallyHidden>Device Code</Form.Label>
          <Form.Control required
            id="device_code_tb"
            name="pin"
            autoComplete="off"
            autoFocus={true}
            placeholder="Enter 8-digit code"
            value={pin}
            onChange={(e: FocusEvent<HTMLInputElement>) => setPin(e.currentTarget.value)} />
        </Form.Group>
        <Button variant="primary" type="submit" disabled={pin.length <= 0} className="me-2">Approve</Button>
        <Button variant="outline-primary" onClick={handleCancel}>Cancel</Button>
      </Form>
    </Card.Body>
  </Card>;
}

export default React.memo(EstablishedConnectionComponent);